import { configureStore } from "@reduxjs/toolkit";
import StudentsTableReducer from "./reducers/StudentsTableSlice";
import SRSApplicantSlice from "./reducers/SRSApplicantSlice";
import AppStatusReducer from "./reducers/AppStatusSlice";
import SchoolContactReducer from "./reducers/SchoolContactSlice";
import CredentialReducer from "./reducers/CredentialsSlice";
import PropertiesReducer from "./reducers/PropertiesSlice";
import SchoolReportReducer from "./reducers/SchoolReportSlice";
import ApplicantProfileReducer from "./reducers/ApplicantProfileSlice";
import Year12QualReducer from "./reducers/Year12QualSlice";
import Year11QualReducer from "./reducers/Year11QualSlice";
import RatingsReducer from "./reducers/RatingsSlice";
import LoginTimeOutReducer from "./reducers/LoginTimeOutSlice";
import WhitelabelReducer from "./reducers/WhitelabelSlice";
import GlobalUIReducer from "./reducers/GlobalUiSlice";
import EASSlice from "./reducers/EASSlice";
import CommentSlice from "./reducers/CommentSlice";
import DocumentSlice from "./reducers/DocumentSlice";

export const store = configureStore({
  devTools: {
    name: "srs-utas"
  },
  reducer: {
    appStatus: AppStatusReducer,
    students: StudentsTableReducer,
    srsApplicants: SRSApplicantSlice,
    schoolContact: SchoolContactReducer,
    credentials: CredentialReducer,
    properties: PropertiesReducer,
    schoolReportSettings: SchoolReportReducer,
    applicantProfile: ApplicantProfileReducer,
    year12Qual: Year12QualReducer,
    year11Qual: Year11QualReducer,
    ratings: RatingsReducer,
    loginTimeout: LoginTimeOutReducer,
    whitelabel: WhitelabelReducer,
    globalUI: GlobalUIReducer,
    eas: EASSlice,
    comments: CommentSlice,
    documents: DocumentSlice
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
